<template>
    <div class="form-item">
        <div class="label" :class="{'label-require':attr.required}"> {{attr.title}}</div>
        <van-field v-model="valueInput" :name="attr.name" :placeholder="attr.description" :rules="[
              {
                required: attr.required ,
                validator: attr.required ? Validator : null,
                message: attr.message,
              },
            ]" />

    </div>
</template>

<script>
import { isIdCard } from '@/utils/filters.js';
export default {
    name: 'DefaultInput',
    props: {
        attr: {
            type: Object,
            default: () => {
                return {};
            },
        },
        value: {
            type: String,
        },
    },
    computed: {
        valueInput: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },

    methods: {
        Validator() {
            if (this.attr.validator == 'isValidPhoneNumber') {
                return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(this.valueInput);
            } else if (this.attr.validator == 'validateChineseIDCard') {
                return isIdCard(this.valueInput);
            } else if (this.attr.validator == 'isValidEmail') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(this.valueInput);
            } else if (this.attr.validator == 'isValidPassportNumber') {
                return this.isValidPassportNumber();
            } else if (this.attr.validator == 'isValidURL') {
                return this.isValidURL();
            } else if (this.attr.validator == 'isValidName') {
                return this.isValidateName(this.valueInput);
            }
            return null;
        },

        // 验证网址格式是否正确
        isValidURL(url) {
            // 基本的网址正则表达式，包含协议部分如http、https，并且以合法的域名结尾
            let urlRegexp = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
            return urlRegexp.test(url);
        },
        // 验证护照号码格式是否正确（示例验证，具体国家可根据要求修改）
        isValidPassportNumber(passportNumber) {
            // 假设护照号码为8位或9位字母和数字的组合
            let passportRegexp = /^[A-Za-z0-9]{8,9}$/;
            return passportRegexp.test(passportNumber);
        },

        isValidateName(name) {
            // 定义不允许的关键字
            const keywords = ['先生', '小姐', '女士', '老师', '某人', '某某', '*', '老板'];
            if (name.length === 1) {
                return false;
            }
            for (let i = 0; i < keywords.length; i++) {
                if (name === keywords[i]) {
                    return false;
                }
            }
            return true;
        },
        isValidPhoneNumber(phoneNumber) {
            // 中国大陆手机号码格式为11位数字，以1开头
            let phoneRegexp = /^1\d{10}$/;
            return phoneRegexp.test(phoneNumber);
        },
        // 判断一个值是否为数字
        isNumber(value) {
            return typeof value === 'number' && !isNaN(value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.form-item {
    background: #fff;
    // box-shadow: 2px 2px 10px 2px #dbdbdb;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    padding: 5px 0;
    .label {
        font-size: 14px;
        color: #646566;
        padding: 0 18px;
        position: relative;
        span {
            color: $font_color;
            margin: 0 0px 0 6px;
        }
    }
    .label {
        color: #333;
        font-weight: bold;
    }
    .label-require::before {
        position: absolute;
        left: 8px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
    }
}
</style>